// extracted by mini-css-extract-plugin
var _1 = "G4TRa";
var _2 = "nQNz1";
var _3 = "R0wZE";
var _4 = "WPLRk";
export { _1 as "layout", _2 as "layoutLightGrey", _3 as "lightGrey", _4 as "main" }
